import { Fragment, useEffect, useMemo, useState } from 'react';
import { Avatar, Box, Divider, IconButton, Stack, Typography, useTheme } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { format } from 'date-fns';
import { INewAccount } from 'constants/new_accounts.constants';

export const BONotesDrawer = (props: { toggleDrawer: () => void; open: boolean; newAccount: INewAccount }) => {
	const theme = useTheme();
	const { toggleDrawer, open, newAccount } = props;
	const t = useAppSelector(selectTranslations);
	const formatDate = (dateString: string): string => {
		const date = new Date(dateString);
		const formattedDate = format(date, 'dd.MM.yyyy');
		const time = format(date, 'HH:mm');

		const writtenAt = t('page.newAccount.tables.writtenAt');
		const atHour = t('page.newAccount.tables.atHour');

		return `${writtenAt} - ${formattedDate} ${atHour} ${time}`;
	};
	return (
		<Fragment>
			<Stack direction="row" alignItems="center" spacing={1}>
				<Avatar src="/icons/warning-orange.svg" sx={{ width: 18, height: 18 }} />
				<Typography variant="boldBody6">{t('page.newAccount.tables.boNotes')}</Typography>
				<IconButton onClick={toggleDrawer}>
					{open ? (
						<ArrowDropUpIcon sx={{ color: '#F36F23' }} />
					) : (
						<ArrowDropDownIcon sx={{ color: '#F36F23' }} />
					)}
				</IconButton>
			</Stack>
			{open && (
				<Box
					sx={{
						height: 'auto',
						padding: 2,
					}}
				>
					{_.orderBy(newAccount?.allDenyMessages, ['updatedAt'], ['desc'])?.map(
						(denyMessage: any, index: number) => {
							return (
								<Stack gap={1} key={index}>
									<Typography variant="boldBody7">{formatDate(denyMessage.updatedAt)}</Typography>
									<Typography variant="boldBody4">{denyMessage.message}</Typography>
									{index < newAccount.allDenyMessages.length - 1 && <Divider sx={{ marginY: 3 }} />}
								</Stack>
							);
						}
					)}
				</Box>
			)}
		</Fragment>
	);
};
